import { Box, makeStyles, Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import PorCliente from "./PorCliente";
import PorUsuario from "./PorUsuario";
import PorClienteDescricaoCompleta from "./PorClienteDescricaoCompleta";
import PorClienteDescricaoCompletaInterna from "./PorClienteDescricaoCompletaInterna";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    height: "92%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: 200,
  },
  container: {
    padding: theme.spacing(0),
  },
}));

const Relatorios = () => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={tabValue}
        onChange={handleTabChange}
        className={classes.tabs}
      >
        <Tab label={"Por Cliente"} />
        <Tab label={"Por Cliente - Desc. Completa"} />
        <Tab label={"Por Cliente - Desc. Comp. e Int."} />
        <Tab label={"Por Usuário"} />
      </Tabs>
      <Box py={2} px={1} width={"70%"}>
        {tabValue === 0 && <PorCliente />}
        {tabValue === 1 && <PorClienteDescricaoCompleta />}
        {tabValue === 2 && <PorClienteDescricaoCompletaInterna />}
        {tabValue === 3 && <PorUsuario />}
      </Box>
    </div>
  );
};

export default Relatorios;
